export class NotifyOldWebViewDevice {
  static readonly type = '[Device] Notify Old WebView Device';
}
